class FlangeIntegralCalculator {
    constructor() {
        /* =========================
           1. PRE-CONFIGURATION
        ========================= */
        this.overboltingSelect = "";
        this.bSelect = "";

        /* =========================
           2. MATERIALS
        ========================= */
        this.flangeMaterial = null;
        this.boltMaterial = null;
        this.gasket = null;

        this.materialSearch = "";
        this.boltSelecionado = "";
        this.gasketSelecionado = "";

        /* =========================
           3. DESIGN DATA
        ========================= */
        this.designPressureInternal = 0;
        this.designTemperature = 0;
        this.corrosionAllowance = 0;
        this.shellAllowStress = 0;

        /* =========================
           4. FLANGE ALLOWABLE STRESS
        ========================= */
        this.sfo = 0;
        this.sfa = 0;

        /* =========================
           5. BOLTING ALLOWABLE STRESS
        ========================= */
        this.sbo = 0;
        this.sba = 0;

        /* =========================
           6. FLANGE
        ========================= */
        this.odFlange = null;
        this.idFlange = null;
        this.centerBoltDiameter = null;
        this.loadReactionGasketDiameter = null;

        this.thicknessHubSmallEnd = null;
        this.thicknessHubBack = 0;

        this.mensagemG1 = "";

        this.hubLength = null;

        this.R = 0;
        this.f = 0;

        this.mensagemF = "";

        this.b1 = 0;

        this.mensagemB1 = "";

        this.larguraMinimaJunta = 0;

        /* =========================
           7. BOLTING
        ========================= */
        this.boltDiameter = "";
        this.pitchDiameter = null;
        this.boltsQuantity = null;
        this.rootDiameter = 0;

        this.frictionFactor = null;
        this.torqueMinimo = 0;
        this.torqueMaximo = 0;

        /* =========================
           8. GASKET
        ========================= */
        this.odGasket = null;
        this.idGasket = null;

        this.gasketCrushingPressure = null;

        this.Ag = 0;
        this.Sya = 0;
        this.Sys = 0;

        this.valorCampoSemNome1 = 0;
        this.unidadeCampoSemNome1 = "";

        this.valorCampoSemNome2 = 0;
        this.unidadeCampoSemNome2 = "";

        this.resultGasket = "";

        /* =========================
           9. PARAMETERS
        ========================= */
        this.N = 0;
        this.b0 = 0;
        this.b = 0;
        this.y = 0;
        this.m = 0;

        /* =========================
           10. CALCULATED VALUES
        ========================= */
        this.Wm2 = 0;
        this.Hp = 0;
        this.H = 0;
        this.Wm1 = 0;
        this.Am = 0;
        this.Ab = 0;
        this.W1 = 0;
        this.W2 = 0;
        this.W = 0;

        /* =========================
           11. OPERATING CONDITIONS
        ========================= */
        this.Hd = 0;
        this.Hg = 0;
        this.Ht = 0;

        this.hd = 0;
        this.hg = 0;
        this.ht = 0;

        this.Md = 0;
        this.Mg = 0;
        this.Mt = 0;
        this.Mop = 0;

        /* =========================
           12. ATMOSPHERIC CONDITIONS
        ========================= */
        this.Hg2 = 0;
        this.Matm = 0;

        this.CF = 0;
        this.Mo = 0;
        this.Ma = 0;

        /* =========================
           13. SHAPE CONSTANTS
        ========================= */
        this.K = 0;
        this.T = 0;
        this.Z = 0;
        this.Y = 0;
        this.U = 0;

        this.g1g0 = 0;
        this.h0 = 0;
        this.hh0 = 0;

        this.F = 0;
        this.V = 0;

        this.fShape = 0;

        this.e = 0;
        this.d = 0;
        this.t = null;
        this.beta = 0;
        this.L = 0;

        /* =========================
           14. STRESS CALCULATIONS
        ========================= */
        this.SH_operating = 0;
        this.SH_ambient = 0;

        this.SR_operating = 0;
        this.SR_ambient = 0;

        this.ST_operating = 0;
        this.ST_ambient = 0;

        this.Smax_operating = 0;
        this.Smax_ambient = 0;

        this.SH_ambient_1 = 0;
        this.SH_ambient_2 = 0;

        this.SR_ambient_1 = 0;
        this.SR_ambient_2 = 0;

        this.ST_ambient_1 = 0;
        this.ST_ambient_2 = 0;

        this.Smax_ambient_1 = 0;
        this.Smax_ambient_2 = 0;

        /* =========================
           TEMPERATURE TABLE
        ========================= */
        this.rangeDesignTemperatureCelsius = {
            '37,78': '0',
            '65,56': '0',
            '93,33': '0',
            '121,11': '0',
            '148,89': '0',
            '204,44': '0',
            '260,00': '0',
            '315,56': '0',
            '343,33': '0',
            '371,11': '0',
            '398,89': '0',
            '426,67': '0',
            '454,44': '0',
            '482,22': '0',
            '510,00': '0',
            '537,78': '0',
            '565,56': '0',
            '593,33': '0',
            '621,11': '0',
            '648,89': '0',
            '676,67': '0',
            '704,44': '0',
            '732,22': '0',
            '760,00': '0',
            '787,78': '0',
            '815,56': '0',
            '843,33': '0',
            '871,11': '0',
            '898,89': '0',
        };
    }
}

export default FlangeIntegralCalculator;